'use client';

import styles from './ProfilePic.module.css';
import Link from 'next/link';
import { memo } from 'react';

interface ProfilePicProps {
  profilePicUrl: string | null;
  width?: number;
  height?: number;
}

// Use memo to prevent unnecessary re-renders
const ProfilePic = memo(function ProfilePic({ profilePicUrl, width = 24, height = 24 }: ProfilePicProps) {
  return (
    <Link href="/profile" className={styles.profileLink}>
      <div className={styles.container}>
        {profilePicUrl ? (
          <img 
            src={profilePicUrl}
            alt="Profile"
            width={width}
            height={height}
            className={styles.profileImage}
            loading="eager" // This tells the browser to load this image with high priority
          />
        ) : (
          <div className={styles.gradientBackground} />
        )}
      </div>
    </Link>
  );
});

export default ProfilePic;